import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import moment from 'moment';
import _ from 'lodash';

function FulfillmentOrderErrorLogListTemplate(props) {
	const { errorsList, orderId, t, timezone, format } = props;
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{translate(['FULFILLMENTORDERVIEW.ERRORLOG.MODALTITLE', { id: orderId }])}</h3>
			</div>
			<div className="ReactModal__body">
				{errorsList.length > 0 &&
					_.map(errorsList, (item, index) => {
						return (
							<div key={index} className="message__section">
								<p className="message__date">
									{moment(item.timeStamp)
										.tz(timezone)
										.format(format)}
								</p>
								{item.failureNotification.length > 0 && (
									<div className="message message--error spc--bottom--sml">
										<p>{t('FULFILLMENTORDERVIEW.ERRORLOG.FAILURENOTIFICATIONS')}</p>
										<ul>
											<li>{item.failureNotification}</li>
										</ul>
									</div>
								)}
								{item.notification.length > 0 && (
									<div className="message message--error">
										<p>{t('FULFILLMENTORDERVIEW.ERRORLOG.NOTIFICATIONS')}</p>
										<ul>
											<li>{item.notification}</li>
										</ul>
									</div>
								)}
							</div>
						);
					})}
			</div>
		</section>
	);
}

export default defaultTemplate(FulfillmentOrderErrorLogListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/FulfillmentOrderErrorLogListTemplate.jsx